import * as React from 'react';
import PropTypes from 'prop-types';
import { Suspense, lazy } from 'react';
import { AppErrorProvider, Show, useBrokenFlowModal, useSessionExpiredModal, ErrorNamespaceProvider } from '@edreamsodigeo/frontend-core';
import { CheckoutFunnelErrorTranslationsProvider } from './TranslationsFunnelProvider';
const CheckoutBrokenFlow = /*#__PURE__*/lazy(() => import('./components/BrokenFlowCheckout'));
const CheckoutSessionExpired = /*#__PURE__*/lazy(() => import('./components/SessionExpiredCheckout'));
const CheckoutFunnelBrokenFlowModal = () => {
  const brokenFlowModalProps = useBrokenFlowModal();
  return /*#__PURE__*/React.createElement(CheckoutFunnelErrorTranslationsProvider, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Show, {
    when: brokenFlowModalProps.isOpen
  }, /*#__PURE__*/React.createElement(CheckoutBrokenFlow, null))));
};
const CheckoutFunnelSessionExpiredModal = () => {
  const SessionExpiredModalProps = useSessionExpiredModal();
  return /*#__PURE__*/React.createElement(CheckoutFunnelErrorTranslationsProvider, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Show, {
    when: SessionExpiredModalProps.isOpen
  }, /*#__PURE__*/React.createElement(CheckoutSessionExpired, null))));
};
export default function Container({
  children
}) {
  return /*#__PURE__*/React.createElement(AppErrorProvider, {
    logService: "/frontend-api"
  }, /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
    namespace: `flights_checkout`
  }, children), /*#__PURE__*/React.createElement(CheckoutFunnelBrokenFlowModal, null), /*#__PURE__*/React.createElement(CheckoutFunnelSessionExpiredModal, null));
}
Container.propTypes = {
  children: PropTypes.node.isRequired
};